module.exports = __webpack_public_path__ + "img/house.46bf739a.svg";